import { render, staticRenderFns } from "./IgManageFlow.vue?vue&type=template&id=8079a0a8&"
import script from "./IgManageFlow.vue?vue&type=script&lang=js&"
export * from "./IgManageFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports